var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config)?_c('img',{staticClass:"w-full",attrs:{"src":require(("@/assets/view/" + _vm.disease + "/logos.png")),"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }